<script>
  import {External, M} from "../../external";
  export let data, meta, globalStyle, onChange;
</script>

<tr>
  <th>
    <table>
      <tr>
        <!-- Product Row -->
        <table class="row" align="center" cellpadding="0" cellspacing="0" role="presentation">
          <tr class="mobile-valign-top">
            <th class="column mobile-4" width="145" style="padding-left: 30px; padding-right: 10px; text-align: left;">
              <a style="display: inline-block; text-decoration: none;">
                <img src="{External.resources + '/images/marketing/placeholders/310x430.png'}" alt="Kant Sailor" width="100" style="max-width:100px;border: none; width: 100%;" />
              </a>
            </th>
            <th class="column mobile-8" width="255" style="padding-left: 10px; padding-right: 10px; font-weight: 400; text-align: left;">
              <div class="serif" style="color: #1F2225; font-size: 16px; font-weight: 700; margin-bottom: 15px;">{M.PRODUCT_NAME}</div>
              <div class="sans-serif" style="color: #969AA1; font-size: 13px; line-height: 20px;">{M.PRODUCT_VARIATION_SAMPLE}</div>
            </th>
            <th class="column mobile-8 mobile-offset-4 mobile-padding-top-mini" width="200" style="padding-left: 10px; padding-right: 30px; font-weight: 400;">
              <div class="sans-serif mobile-text-left" style="color: #969AA1; font-size: 13px; line-height: 13px; text-align: right;">
                <strike>{External.Tools.currencyToStrWithSymbol(79)}</strike>&nbsp;<b style="font-size: 16px; color: #1F2225;">{External.Tools.currencyToStrWithSymbol(54)}</b>
              </div>
            </th>
          </tr>
          <tr>
            <th class="column" colspan="3" width="640" style="padding-left: 30px; padding-right: 30px;">
              <table class="divider" cellpadding="0" cellspacing="0" width="100%" role="presentation">
                <tr>
                  <th height="60">
                    <div style="border-top: 1px solid #EEEEEE; line-height: 0;">&nbsp;</div>
                  </th>
                </tr>
              </table>
            </th>
          </tr>
        </table>
        <!-- /Product Row -->

        <!-- Product Row -->
        <table class="row" align="center" cellpadding="0" cellspacing="0" role="presentation">
          <tr class="mobile-valign-top">
            <th class="column mobile-4" width="145" style="padding-left: 30px; padding-right: 10px; text-align: left;">
              <a style="display: inline-block; text-decoration: none;">
                <img src="{External.resources + '/images/marketing/placeholders/310x430.png'}" alt="Kant Sailor" width="100" style="max-width:100px;border: none; width: 100%;" />
              </a>
            </th>
            <th class="column mobile-8" width="255" style="padding-left: 10px; padding-right: 10px; font-weight: 400; text-align: left;">
              <div class="serif" style="color: #1F2225; font-size: 16px; font-weight: 700; margin-bottom: 15px;">{M.PRODUCT_NAME}</div>
              <div class="sans-serif" style="color: #969AA1; font-size: 13px; line-height: 20px;">{M.PRODUCT_VARIATION_SAMPLE}</div>
            </th>
            <th class="column mobile-8 mobile-offset-4 mobile-padding-top-mini" width="200" style="padding-left: 10px; padding-right: 30px; font-weight: 400;">
              <div class="sans-serif mobile-text-left" style="color: #969AA1; font-size: 13px; line-height: 13px; text-align: right;">
                <strike>{External.Tools.currencyToStrWithSymbol(79)}</strike>&nbsp;<b style="font-size: 16px; color: #1F2225;">{External.Tools.currencyToStrWithSymbol(54)}</b>
              </div>
            </th>
          </tr>
          <tr>
            <th class="column" colspan="3" width="640" style="padding-left: 30px; padding-right: 30px;">
              <table class="divider" cellpadding="0" cellspacing="0" width="100%" role="presentation">
                <tr>
                  <th height="60">
                    <div style="border-top: 1px solid #EEEEEE; line-height: 0;">&nbsp;</div>
                  </th>
                </tr>
              </table>
            </th>
          </tr>
        </table>
        <!-- /Product Row -->
      </tr>
    </table>
  </th>
</tr>
